<template>
	<div class="wc-payment gift-card" :class="{'active': value}">
		<div class="wc-payment-row1">
			<input :name="field.name" :id="field.name + '-1'" :type="field.type" @keyup="onKeyUp($event)" @change="onKeyUp($event)" :checked="field.value" placeholder=" " v-model="value" />
			<label :for="field.name + '-1'">
				<BaseCmsLabel code="use_value_card" />
				<span v-if="info.amount > 0" class="wc-gift-amount"
					><strong><BaseUtilsFormatCurrency :price="info.amount" /></strong
				></span>
			</label>
		</div>
		<WebshopGiftCard :class="{'active': value}" :data="data" :field="data[1]" />
	</div>
	<div v-if="value && totalRemain > 0 && totalRemain != total_regular" class="wc-gift-to-pay" v-html="labels.get('value_card_total_remain').replace('%PRICE%', formatCurrency(totalRemain))"></div>
</template>

<script setup>
	import { useField, defineRule, useValidateForm } from 'vee-validate';

	const {formatCurrency} = useCurrency();
	const labels = useLabels();

	const props = defineProps({
		mode : {
			type: String,
			default: '',
		},
		field: {
			type: null,
			default: false,
		},
		info: {
			type: null,
			default: false,
		},
		data: {
			type: null,
			default: false,
		},
		total: {
			type: null,
			default: false,
		}
	})
	const isDirty = ref(0);

	//gift card amount remain
	const totalRemain = computed(() => props.total.total)
	const total_regular = computed(() => props.total.total_regular)

	// validation rules
	let validationShema = 'related:'+props.field.related_fields+'|'

	// process input
	const { errorMessage, value, resetField } = useField(props.field.name, validationShema, {initialValue: props.field.value})
	let f = props.data
	const fieldIndex = f.findIndex((obj => obj.name == props.field.name))

	// save user input to store and update "valid" property
	const validateForm = useValidateForm();

	async function onKeyUp(event) {
		if(event.key != 'Tab' && event.key != 'Escape') {
			f[fieldIndex].value = value.value;
			isDirty.value = 1;
			await validateForm();
		}
	}

	// clear field on parent checkbox update
	if(props.field.related_fields) {
		const relatedField = props.data?.find(obj => obj.name == props.field.related_fields);
		watch(
			() => relatedField.value,
			() => {
				resetField({value: ''});
				props.data[fieldIndex].value = '';
				isDirty.value = 0;
			}
		)
	}

	// form validation patterns
	defineRule('related', (value, [related], ctx) => {
		if(related == 'use_gift_card' && ctx.form[related]) {
			if (!value || !value.length || value.match(/^ *$/) !== null) {
				return labels.get('error_not_empty');
			}
			return true
		}

		return true
	});
</script>

<style lang="less" scoped>
	.wc-payment{
		margin-bottom: -1px; order: 2;
		&.gift-card{
			margin-bottom: 20px; order: 1;
			input[type=checkbox]+label{
				display: flex; align-items: center; width: 100%; padding: 17px 30px 17px 55px; border: 1px solid @borderColor; font-size: 15px; font-weight: 600;
				@media (max-width: @m){padding-left: 50px;}
			}
			input[type=checkbox]+label:before{
				top: 17px; left: 21px; border-color: @inputTextColor;
				@media (max-width: @m){left: 15px;}
			}
			&>input[type=checkbox]:checked + label{
				background: #EBF4FF; border-color: @blue; color: @blue; z-index: 1;
				.desc, .wc-payment-leanpay-disabled-desc{color: @textColor;}
			}
			&.active .wc-payment-row1>label:before{box-shadow: none}
		}
		&.active .wc-payment-row1>label{
			background: #EBF4FF; border-color: @blue!important; color: @blue; z-index: 1;
			&:before{background: @blue; border-color: @blue!important; box-shadow: inset 0 0 0 3px @white;}
		}
		&.wc-disabled{
			pointer-events: none;
			input[type=radio]+label{color: #b2c7dd;}
			input[type=radio]+label:before{border-color: #D7E4EF; background: transparent;}
		}
		input[type=radio]+label{
			display: flex; align-items: center; width: 100%; padding: 17px 30px 17px 55px; border: 1px solid @borderColor; font-size: 15px; font-weight: 600;
			@media (max-width: @m){padding-left: 50px;}
		}
		input[type=radio]+label:before{
			top: 17px; left: 21px; border-color: @inputTextColor;
			@media (max-width: @m){left: 15px;}
		}
		&>input[type=radio]:checked + label{
			background: #EBF4FF; border-color: @blue; color: @blue; z-index: 1;
			.desc, .wc-payment-leanpay-disabled-desc{color: @textColor;}
		}
	}
	.wc-payment-row1{flex-grow: 1;}

	.wc-gift-amount{flex-grow: 1; text-align: right;}
	.wc-gift-to-pay{margin-bottom: 15px; font-weight: bold; order: 2;}
</style>
